export enum VideoTab {
  DstVideo = 'dstVideo',
  LipSyncVideo = 'lipSyncVideo',
  SrcVideo = 'srcVideo',
}
